<template>
  <div>
    <validation-observer
      ref="formIndividual"
      @change="submitForm"
      v-if="individualCheck"
      #default="{ invalid }"
    >
      <b-form @submit.prevent="addLeadsIndividual">
        <b-row>
          <b-col :cols="isEdit ? 10 : 12">
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              name="Lead Source"
              vid="Lead Source"
            >
              <b-form-group label="Lead Source" label-for="h-First">
                <b-form-select
                  v-model="profiledetails.source.leadClientDetailId"
                  :options="sourceOptions"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="2" v-if="isEdit" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('SOURCE')"
            >
              Add Source
            </b-button>
          </b-col>
          <!-- username -->

          <b-col cols="12">
            <b-form-group label="Sales Person" label-for="h-First">
              <validation-provider
                v-slot="{ errors }"
                name="Sales Person"
                vid="Sales Person"
              >
                <b-form-select
                  v-model="leadId.salesPersonId"
                  :options="optionsSalesPerson"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <validation-provider
              rules="required"
              name="First Name"
              v-slot="{ errors }"
            >
              <b-form-group label="First Name" label-for="h-firstName">
                <b-form-input
                  id="firstName"
                  placeholder="First Name"
                  v-model="leadId.otherName"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <validation-provider
              rules="required"
              name="Last Name"
              v-slot="{ errors }"
            >
              <b-form-group label="Last Name" label-for="h-lastName">
                <b-form-input
                  id="lastName"
                  placeholder="Last Name"
                  v-model="leadId.surname"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- <b-col cols="12">
            <validation-provider rules="required" name="fullName" v-slot="{ errors }">
            <b-form-group label="Full Name" label-for="h-fullName">
                 <b-form-input id="fullName" placeholder="Full Name" v-model="fullNameData" />
                 <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          </b-col> -->
          <!-- email -->
          <b-col cols="12">
            <validation-provider
              rules="email_regex"
              name="Email"
              v-slot="{ errors }"
            >
              <b-form-group label="Email" label-for="d-email">
                <b-form-input
                  id="d-email"
                  type="email"
                  placeholder="Enter your email (e.g., example@domain.com)"
                  v-model="leadId.email"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- DOB  -->
          <b-col cols="12">
            <b-form-group label="Date of Birth" label-for="dob">
              <flat-pickr
                v-model="leadId.dob"
                class="form-control"
                :config="config"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Address" label-for="h-Address">
              <b-form-input
                id="h-Address"
                placeholder="Address"
                v-model="leadId.addressLine1"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Street Name" label-for="h-Street">
              <b-form-input
                id="h-Street"
                placeholder="Street Name"
                v-model="leadId.addressLine2"
              />
            </b-form-group>
          </b-col>

          <b-col cols="10">
            <b-form-group label="City" label-for="h-City">
              <b-form-select
                v-model="profiledetails.city.leadClientDetailId"
                :options="cityOptions"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="isEdit" cols="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('CITY')"
            >
              Add City
            </b-button>
          </b-col>
          <b-col cols="12">
            <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
            <b-form-group label="Tel " label-for="h-tel">
              <b-form-input
                id="h-tel"
                placeholder="Tel"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                v-model="leadId.tel"
              />
              <!-- <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small> -->
            </b-form-group>
            <!-- </validation-provider> -->
          </b-col>

          <b-col cols="12">
            <b-form-group label="Category" label-for="h-specialInstructions">
              <b-form-input
                id="h-specialInstructions"
                placeholder="Category"
                v-model="leadId.fieldInstruction"
              />
            </b-form-group>
          </b-col>

          <b-col :cols="isEdit ? 10 : 12">
            <b-form-group label="Job Title" label-for="h-title">
              <b-form-select
                v-model="profiledetails.jobTitle.leadClientDetailId"
                :options="jobTitleOptions"
              />
            </b-form-group>
          </b-col>

          <b-col cols="2" v-if="isEdit" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('JOBTITLE')"
            >
              Add Job Title
            </b-button>
          </b-col>
          <!-- Hobbies -->
          <b-col :cols="isEdit ? 10 : 12">
            <b-form-group label="Hobbies" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Hobbies"
                label="itemTitle"
                v-model="selectedHobbies"
                :options="hobbiesOptions"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="isEdit" cols="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('HOBBIE')"
            >
              Add Hobby
            </b-button>
          </b-col>
          <b-col :cols="isEdit ? 10 : 12">
            <b-form-group label="Products interested in" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Products Interested in"
                label="itemTitle"
                v-model="ProductInterestSelected"
                :options="productInterestOptions"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="isEdit" cols="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('PRODUCTINTEREST')"
            >
              Add Product Interest
            </b-button>
          </b-col>
          <!-- segments -->
          <b-col cols="12">
            <b-form-group label="Marketing Segment" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Marketing Segments"
                label="itemTitle"
                v-model="selectedSegments"
                :options="segmentOptions"
              />
            </b-form-group>
          </b-col>
          <!-- Percentage -->
          <b-col cols="12">
            <b-form-group label="Percentage" label-for="d-percentage">
              <div class="input-group">
                <b-form-input
                  id="d-percentage"
                  type="number"
                  placeholder="Percentage"
                  v-model="leadId.percentage"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </b-form-group>
          </b-col>
          <b-col class="12">
            <CustomFieldsDetails
              :AdditionalFields="leadId.additionalFields"
              :ModuleReference="'LeadClient'"
              @onchange="additionalFieldChanges"
            />
          </b-col>

          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="primary"
              class="mr-1"
              @click="addLeadsIndividual"
            >
              <b-spinner small v-if="loading" />
              Submit
            </b-button>

            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="resetForm"
            >
              Reset
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <validation-observer
      ref="formCompany"
      v-if="!individualCheck"
      @change="submitForm"
    >
      <b-form @submit.prevent="addLeadsCompany">
        <b-row>
          <!-- username -->
          <b-col cols="10">
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              name="Lead Source"
              vid="Lead Source"
            >
              <b-form-group label="Lead Source" label-for="h-First">
                <b-form-select
                  v-model="profiledetails.source.leadClientDetailId"
                  :options="sourceOptions"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('SOURCE')"
            >
              Add Source
            </b-button>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Sales Person" label-for="h-First">
              <validation-provider
                rules="required"
                v-slot="{ errors }"
                name="Sales Person"
                vid="Sales Person"
              >
                <b-form-select
                  v-model="leadId.salesPersonId"
                  :options="optionsSalesPerson"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Company Name" label-for="h-company">
              <validation-provider
                rules="required"
                name="Company Name"
                #default="{ errors }"
              >
                <b-form-input
                  id="h-full"
                  placeholder="Name"
                  v-model="leadId.otherName"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- email -->
          <b-col cols="12">
            <validation-provider
              rules="email_regex"
              name="Email"
              v-slot="{ errors }"
            >
              <b-form-group label="Email" label-for="d-email">
                <b-form-input
                  id="d-email"
                  type="email"
                  placeholder="Enter your email (e.g., example@domain.com)"
                  v-model="leadId.email"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Address" label-for="h-Address">
              <b-form-input
                id="h-Address"
                placeholder="Address"
                v-model="leadId.addressLine1"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Street Name" label-for="h-Street">
              <b-form-input
                id="h-Street"
                placeholder="Street Name"
                v-model="leadId.addressLine2"
              />
            </b-form-group>
          </b-col>

          <b-col cols="10">
            <b-form-group label="City" label-for="h-City">
              <b-form-select
                v-model="profiledetails.city.leadClientDetailId"
                :options="cityOptions"
              />
            </b-form-group>
          </b-col>
          <b-col cols="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('CITY')"
            >
              Add City
            </b-button>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Company Tel" label-for="h-tel">
              <b-form-input
                id="h-tel"
                placeholder="Company Tel"
                type="number"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                v-model="leadId.tel"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Category" label-for="h-specialInstructions">
              <b-form-input
                id="h-specialInstructions"
                placeholder="Category"
                v-model="leadId.fieldInstruction"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Website" label-for="h-Website">
              <b-form-input
                id="h-Website"
                placeholder="Website"
                v-model="leadId.website"
              />
            </b-form-group>
          </b-col>

          <!-- <b-col cols="12">
            <b-form-group label="Vat Number" label-for="h-Number">
              <b-form-input id="h-Number" placeholder="Vat Number" v-model="leadId.vatNumber" />
            </b-form-group>
          </b-col> -->

          <b-col cols="12">
            <b-form-group label="Company BRN" label-for="h-Number">
              <b-form-input
                id="h-Number"
                placeholder="Individual BRN"
                v-model="leadId.brn"
              />
            </b-form-group>
          </b-col>
          <b-col cols="10">
            <b-form-group label="Products interested in" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Products Interested in"
                label="itemTitle"
                v-model="ProductInterestSelected"
                :options="productInterestOptions"
              />
            </b-form-group>
          </b-col>
          <b-col cols="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('PRODUCTINTEREST')"
            >
              Add Product Interest
            </b-button>
          </b-col>
          <!-- segments -->
          <b-col cols="12">
            <b-form-group label="Marketing Segment" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Marketing Segments"
                label="itemTitle"
                v-model="selectedSegments"
                :options="segmentOptions"
              />
            </b-form-group>
          </b-col>
          <!-- Percentage -->
          <b-col cols="12">
            <b-form-group label="Percentage" label-for="h-percentage">
              <div class="input-group">
                <b-form-input
                  id="h-percentage"
                  type="number"
                  placeholder="Percentage"
                  v-model="leadId.percentage"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <CustomFieldsDetails
              :AdditionalFields="leadId.additionalFields"
              :ModuleReference="'LeadClient'"
              @onchange="additionalFieldChanges"
            />
          </b-col>

          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="primary"
              class="mr-1"
              @click="addLeadsCompany"
            >
              Submit
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="resetForm"
            >
              Reset
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-modal :id="modalId" :title="modalTitle" hide-footer>
      <b-form @submit.prevent="addItem">
        <b-form-group
          :label="`${this.modalTitle}`"
          label-for="input-new-item"
        >
          <b-form-input
            id="input-new-item"
            v-model="newItem"
            required
            placeholder="Enter new item"
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Add</b-button>
      </b-form>

      <div class="p-1" style="max-height: 500px; overflow-y: auto">
        <b-table
          striped
          hover
          :items="modalOptions"
          responsive
          :fields="fields"
        >
          <template v-slot:cell(name)="data">
            {{
              modalType === "PRODUCTINTEREST" || "HOBBIE"
                ? data.item.itemTitle
                : data.item.text
            }}
          </template>
          <template #cell(actions)="data">
            <b-button
              v-if="HasPermission(PermissionList.Sales_Delete)"
              size="sm"
              variant="danger"
              @click="deleteItem(data.item.value)"
              >Delete</b-button
            >
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormText,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BFormDatalist,
  BFormSelect,
  BModal,
  VBModal,
  BTable,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { ModuleReferenceList } from "@/libs/defaultList";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { extend } from "vee-validate";

import { PermissionList } from "@/libs/defaultList";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";

extend("email_regex", {
  validate: (value) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
  message:
    "Please enter a valid email address in the format example@domain.com",
});
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormText,
    BButton,
    BFormDatalist,
    BDropdown,
    BDropdownItem,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    vSelect,
    flatPickr,
    BModal,
    VBModal,
    BTable,
    CustomFieldsDetails,
  },

  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      id: this.$route.params.id,
      modalId: "",
      modalTitle: "",
      modalType: "",
      newItem: "",
      isEdit: false,
      currentOptions: [],
      fields: [{ key: "name", sortable: true }, { key: "actions" }],
      sourceOptions: [],
      productInterestOptions: [],
      hobbiesOptions: [],
      cityOptions: [],
      jobTitleOptions: [],
      selectedHobbyIds: [],
      selectedProductsInterestedInIds: [],
      optionsSalesPerson: [],
      selectedHobbies: [],
      selectedSegments: [],
      socialMedias: [
        { text: "Facebook", value: 1 },
        { text: "Instagram", value: 2 },
        { text: "LinkedIn", value: 4 },
        //{ text: "Other", value: 0 },
        { text: "Twitter", value: 3 },
      ],
      selected: "Select Social Media",
      ProductInterestSelected: [],
      ///////////////
      required,
      email,
      individualCheck: false,
      moduleList: ModuleReferenceList,
      defaultProfile: {
        source: {
          leadClientDetailId: null,
        },
        city: {
          leadClientDetailId: null,
        },
        jobTitle: {
          leadClientDetailId: null,
        },
        hobbies: [],
        productsInterestedIn: [],
        marketingSegments: [],
      },
      otherName: null,
      surname: null,
      fullNameData: "",
      config: {
        wrap: true,
        maxDate: "today",
      },
    };
  },

  computed: {
    ...mapGetters("leadModule", {
      leadId: "leadId",
      loading: "loading",
    }),

    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("customerModule", {
      details: "details",
      profiledetails: "profiledetails",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    segmentOptions() {
      // Assuming this.segments is the array containing segment data
      return this.segments.map((segment) => {
        return {
          value: segment.segmentId,
          itemTitle: segment.name,
        };
      });
    },

    fullName() {
      let otherName =
        this.leadId.otherName != null ? this.leadId.otherName : "";
      let surName = this.leadId.surname != null ? this.leadId.surname : "";
      return `${otherName} ${surName}`;
    },
    

    modalOptions() {
      if (this.modalType === "PRODUCTINTEREST") {
        return this.productInterestOptions;
      } else if (this.modalType === "SOURCE") {
        return this.sourceOptions;
      } else if (this.modalType === "CITY") {
        return this.cityOptions;
      } else if (this.modalType === "JOBTITLE") {
        return this.jobTitleOptions;
      } else if (this.modalType === "HOBBIE") {
        return this.hobbiesOptions;
      }
      return [];
    },
  },
  watch: {
    fullName(newVal) {
      this.fullNameData = newVal;
    },
  },

  async mounted() {
    await this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
        })
      );
    });
    await this.getSegmentsAction()
      .then((response) => {})
      .catch((response) => {
        console.log(response);
      });
    await this.loadAndRefreshDetails();
    // await this.getLeadByIDAction(this.id).then((res) => {
    //   if (this.leadId.typeDesc === "INDIVIDUAL") {
    //     this.individualCheck = true;
    //     this.selected = this.leadId.sourceDesc;
    //   } else {
    //     this.individualCheck = false;
    //   }
    // });
    this.getCustomerProfileDetailAction(this.id)
      .then(() => {
        if (this.profiledetails.source == null)
          this.profiledetails.source = this.defaultProfile.source;
        if (this.profiledetails.city == null)
          this.profiledetails.city = this.defaultProfile.city;
        if (this.profiledetails.jobTitle == null)
          this.profiledetails.jobTitle = this.defaultProfile.jobTitle;
        if (this.profiledetails.hobbies == null)
          this.profiledetails.hobbies = this.defaultProfile.hobbies;
        if (this.profiledetails.productsInterestedIn == null)
          this.profiledetails.productsInterestedIn =
            this.defaultProfile.productsInterestedIn;
        if (this.profiledetails.marketingSegments == null)
          this.profiledetails.marketingSegments =
            this.defaultProfile.marketingSegments;
      })
      .catch((error) => {
        console.error("Error fetching customer profile details:", error);
      });
    this.fullNameData = this.fullName;
  },
  async beforeMount() {
    await this.checkIndividual();
    await this.loadAndRefreshDetails();
  },
  methods: {
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("leadModule", ["getLeadByIDAction", "updateLeadAction"]),
    ...mapActions("customerModule", [
      "getCustomerProfileDetailAction",
      "getProfileDetailsListAction",
      "addProfileDetailAction",
      "deleteCustomerProfileDetailAction",
    ]),
    ...mapActions("segmentModule", [
      "getSegmentsAction",
      "removeSegmentAction",
      "addSegmentAction",
      "updateSegmentAction",
    ]),
    saveSocialMedia(value, text) {
      this.leadId.source = value;
      this.selected = text;
    },
    async checkIndividual() {
      try {
        await this.getLeadByIDAction(this.id);
        this.individualCheck = this.leadId.typeDesc === "INDIVIDUAL";
        this.selected = this.leadId.sourceDesc;
        return this.individualCheck;
      } catch (error) {
        console.error("Error checking individual:", error);
        this.individualCheck = false;
      }
    },
    getModalTitle(type) {

      switch (type.toLowerCase()) {
          case "hobbie":
            return "Hobbies";
          case "productinterest":
            return "Product Interest";
          case "city":
            return "City";
          case "jobtitle":
            return "Job Title";
          case "source":
            return "Source";
          default:
            return "Unknown Type";
        }
      
      return "";
    },
    showErrorAlert(errorMessage) {
      this.$swal({
        title: "Error!",
        text:
          errorMessage || "An error occurred while adding the profile detail",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    showSuccessAlert(message) {
      this.$swal({
        title: "Success!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    addLeadsIndividual() {
      this.$refs.formIndividual.validate().then((success) => {
        if (success) {
          let payload = {
            id: this.leadId.id,
            otherName: this.leadId.otherName,
            surname: this.leadId.surname,
            email: this.leadId.email,
            addressLine1: this.leadId.addressLine1,
            addressLine2: this.leadId.addressLine2,
            dob: this.leadId.dob != "" ? this.leadId.dob : null,
            tel: this.leadId.tel,
            fieldInstruction: this.leadId.fieldInstruction,
            jobTitle: this.leadId.jobTitle,
            comments: this.leadId.comments,
            salesPersonId: this.leadId.salesPersonId,
            profile: {
              source: this.profiledetails.source?.leadClientDetailId,
              city: this.profiledetails.city?.leadClientDetailId,
              jobTitle: this.profiledetails.jobTitle?.leadClientDetailId,
              hobbies: this.selectedHobbies.map((hobby) => hobby.value),
              productsInterestedIn:
                this.ProductInterestSelected != []
                  ? this.ProductInterestSelected.map((product) => product.value)
                  : [],
              marketingSegments: this.selectedSegments.map(
                (segment) => segment.value
              ),
            },
            percentage: this.leadId.percentage,
            additionalFields: this.leadId.additionalFields,
          };
          console.log("formIndividual payload", payload);
          this.$swal({
            title: "Updating Lead",
            text: "Please wait while the Lead is being updated...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
              this.updateLeadAction(payload)
                .then(() => {
                  this.$swal.hideLoading();
                  this.success();
                })
                .catch(() => {
                  this.$swal.hideLoading();
                  this.error();
                });
            },
          });
        }
      });
    },

    addLeadsCompany() {
      let payload = {
        id: this.leadId.id,
        otherName: this.leadId.otherName,
        surname: this.leadId.surname,
        email: this.leadId.email,
        companyName: this.leadId.companyName,
        addressLine1: this.leadId.addressLine1,
        addressLine2: this.leadId.addressLine2,
        brn: this.leadId.brn,
        tel: this.leadId.tel,
        fieldInstruction: this.leadId.fieldInstruction,
        website: this.leadId.website,
        vatNumber: this.leadId.vatNumber,
        comments: this.leadId.comments,
        type: 1,
        status: 0,
        isActive: true,
        salesPersonId: this.leadId.salesPersonId,
        profile: {
          source: this.profiledetails.source?.leadClientDetailId,
          city: this.profiledetails.city?.leadClientDetailId,
          productsInterestedIn:
            this.ProductInterestSelected &&
            this.ProductInterestSelected.length > 0
              ? this.ProductInterestSelected.map((product) => product.value)
              : [],
          marketingSegments: this.selectedSegments.map(
            (segment) => segment.value
          ),
        },
        percentage: this.leadId.percentage,
        additionalFields: this.leadId.additionalFields,
      };
      this.$swal({
        title: "Updating Lead",
        text: "Please wait while the Lead is being updated...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
          this.updateLeadAction(payload)
            .then(() => {
              this.$swal.hideLoading();
              this.success();
            })
            .catch(() => {
              this.$swal.hideLoading();
              this.error();
            });
        },
      });
    },
    async loadAndRefreshDetails() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the details are loading...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      const typeArrays = {
        SOURCE: this.sourceOptions,
        PRODUCTINTEREST: this.productInterestOptions,
        HOBBIE: this.hobbiesOptions,
        CITY: this.cityOptions,
        JOBTITLE: this.jobTitleOptions,
      };
      await this.getProfileDetailsListAction().then((response) => {
        for (const [type, optionsArray] of Object.entries(typeArrays)) {
          const filteredData = this.details
            .filter((item) => item.type === type)
            .sort((a, b) => a.name.localeCompare(b.name));
          optionsArray.splice(
            0,
            optionsArray.length,
            ...filteredData.map((item) => ({
              value: item.id,
              text: item.name,
              itemTitle:
                type === "PRODUCTINTEREST" || "HOBBIE" ? item.name : undefined,
            }))
          );
        }
      });

      try {
        await this.getCustomerProfileDetailAction(this.id);

        if (this.profiledetails.source == null)
          this.profiledetails.source = this.defaultProfile.source;
        if (this.profiledetails.city == null)
          this.profiledetails.city = this.defaultProfile.city;
        if (this.profiledetails.jobTitle == null)
          this.profiledetails.jobTitle = this.defaultProfile.jobTitle;
        if (this.profiledetails.hobbies == null)
          this.profiledetails.hobbies = this.defaultProfile.hobbies;
        if (this.profiledetails.productsInterestedIn == null)
          this.profiledetails.productsInterestedIn =
            this.defaultProfile.productsInterestedIn;
        if (this.profiledetails.marketingSegments == null)
          this.profiledetails.marketingSegments =
            this.defaultProfile.marketingSegments;

        this.ProductInterestSelected =
          this.profiledetails.productsInterestedIn == null
            ? []
            : this.profiledetails.productsInterestedIn.map((product) => ({
                value: product?.leadClientDetailId,
                itemTitle: product.name,
                text: product.name,
              }));
        console.log("ProductInterestSelected", this.ProductInterestSelected);

        this.selectedHobbies =
          this.profiledetails.hobbies == null
            ? []
            : this.profiledetails.hobbies.map((hobby) => ({
                value: hobby?.leadClientDetailId,
                itemTitle: hobby.name,
                text: hobby.name,
              }));
        this.selectedSegments =
          this.profiledetails.marketingSegments == null
            ? []
            : this.profiledetails.marketingSegments.map((segment) => ({
                value: segment.externalReference,
                itemTitle: this.segments.find(
                  (s) => s.segmentId === segment.externalReference
                )?.name,
              }));
      } catch (error) {
        console.error("Error fetching customer profile details:", error);
      }

      this.$swal.close();
    },

    showModal(type) {
      this.modalType = type;
      this.modalId = `modal-${type.toLowerCase()}`;
      this.modalTitle = `Add ` + this.getModalTitle(type);

      this.currentOptions = this[`${type.toLowerCase()}Options`];
      this.$nextTick(() => {
        this.$bvModal.show(this.modalId);
      });
    },
    addItem() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being added...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      // Validate character limits for "JOBTITLE" and "SOURCE" types
      if (
        (this.modalType === "JOBTITLE" && this.newItem.length > 100) ||
        (this.modalType === "SOURCE" && this.newItem.length > 50)
      ) {
        // Show SweetAlert if character limit is exceeded
        this.$swal({
          title: "Error!",
          text:
            this.modalType === "JOBTITLE"
              ? "Job title should not exceed 100 characters."
              : "Source should not exceed 50 characters.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      const payload = {
        name: this.newItem,
        type: this.modalType,
      };

      this.addProfileDetailAction(payload)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item added successfully!");
          this.newItem = "";
          this.$bvModal.hide(this.modalId);
        })
        .catch((error) => {
          // console.log(error);
          console.log("This is an error: ", error);
          // Extract error message from the API response
          let errorMsg = "Failed to add item.";
          if (error.response?.data?.message) {
            errorMsg = error.response.data.message; // This ensures we show the correct backend error
          }

          // Display the error message using SweetAlert
          this.$swal({
            title: "Error!",
            text: errorMsg,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        });
      this.newItem = "";
      this.$bvModal.hide(this.modalId);
    },
    deleteItem(value) {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being deleted...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.deleteCustomerProfileDetailAction(value)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item deleted successfully!");
        })
        .catch((error) => {
          this.showErrorAlert("Failed to delete item: " + error.message);
          this.$swal.close();
        });
    },
    success() {
      this.$swal({
        title: "Leads!",
        text: "You have successfully updated the lead!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        this.$router.push({ name: "leads-list" });
      });
    },

    // error
    error() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    resetForm() {
      this.$swal({
        title: "Resetting Form",
        text: "Please wait while the form is being reset...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
          this.getLeadByIDAction(this.id)
            .then((res) => {
              this.$swal.hideLoading();
              if (this.leadId.typeDesc === "INDIVIDUAL") {
                this.individualCheck = true;
              } else {
                this.individualCheck = false;
              }
              this.$swal({
                title: "Success",
                text: "The form has been reset.",
                icon: "success",
              });
            })
            .catch((error) => {
              this.$swal.hideLoading();
              this.$swal({
                title: "Error",
                text: `Error resetting form: ${error.message}`,
                icon: "error",
              });
            });
        },
      });
    },

    submitForm() {
      // emit the data to another page
      this.leadId.companyName =
        this.leadId.type == 1 ? this.leadId.otherName : null;
      this.$emit("onchange", this.individual);
    },
    validateDob(newDate) {
      const year = new Date(newDate).getFullYear();
      if (year < 1900 || year > 2100) {
        const nearestYear = Math.min(Math.max(year, 1900), 2100);
        this.custId.dob = new Date(newDate);
        this.custId.dob.setFullYear(nearestYear);
        this.$swal.fire({
          title: "Invalid Year",
          text: `Please select a year between 1900 and 2100.`,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    },
    validatePercentage(value) {
      if (value < 0 || value > 100) {
        this.leadId.percentage = 0;
        // Display a sweet alert to inform the user about the percentage range
        this.$nextTick(() => {
          this.$swal.fire({
            title: "Invalid Percentage",
            text: `Please enter a value between 0 to 100.`,
            icon: "warning",
            confirmButtonText: "OK",
          });
        });
      }
    },
    additionalFieldChanges(customFields) {
      this.leadId.additionalFields = customFields;
    },
  },
  watch: {
    "leadId.dob"(newDate) {
      this.validateDob(newDate);
    },
    "leadId.percentage"(value) {
      this.validatePercentage(value);
    },
  },
  setup(props) {
    return {
      PermissionList,
      HasPermission,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
